import React from 'react';
import { Link, withRouter } from 'react-router-dom';

import { Pages } from './pages/Pages';

class Carousel extends React.Component {

	componentDidMount() {		
		document.title = 'Peapack 100 Anniversary';
		document.body.className = "page-carousel";
	}

	render() {
		return (
			<div id="Carousel">
				<div className="carousel-wrapper"> 
					{ Pages.map(({path, chapter, name, subname, color}, i) => (
						<div key={path} className="item" style={{animationDelay: `${(i*0.1)}s`}}>
							<Link to={path} className="inner" onMouseEnter={this.props.bgHoverState} data-color={color}>
								<span className="box-figure">
									<span className="box-img" style={{backgroundImage: `url(${process.env.PUBLIC_URL}/images${path}-thumbnail.png)`}}></span>
								</span>
								<span className="box-content">
									{(subname !== undefined ?
										(<span className="subname" dangerouslySetInnerHTML={{ __html: subname }} />) : ''
									)}
									<span className="title" dangerouslySetInnerHTML={{ __html: name }} />
									<span className="cta">View More</span>
								</span>
							</Link>
						</div>
					)) }
				</div>
			</div>
		)
	}
}

export default withRouter(Carousel);
